<template>
    <div>
        <v-btn class="mx-2" fab dark small color="light" @click="toggle">
            <v-icon color="#2b2b2b">
                {{ hidden ? "mdi-eye-off" : "mdi-eye" }}
            </v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    props:{
        value:null
    },
    data() {
        return {
            hidden: false
        };
    },
    methods: {
        toggle() {
            this.hidden = !this.hidden;
        }
    },
    created(){
        this.hidden = this.value
    },
    watch:{
        value(v){
            this.hidden =v;
        },
        hidden(v){
            this.$emit("input", v);
            
        }
    }
    
};
</script>

<style></style>
